<template>
  <v-row class="w-100 d-flex align-center justify-center loading-container" :class="{ 'loading-fullscreen': fullscreen }" role="status" aria-live="polite" aria-busy="true">
    <v-col cols="12" sm="4" class="pa-8 text-center">
      <v-card class="h-100 w-100 py-12 px-4 text-center transparent-card" elevation="0">
        <div class="spinner-bounce" style="padding-top: 24px;">
          <v-progress-circular
            :size="80"
            :width="7"
            indeterminate
            color="green darken-2"
            class="spinner-center"
          >
            <v-icon :size="36" color="green" class="spin-icon">{{ selectedIcon }}</v-icon>
          </v-progress-circular>
        </div>
        <p class="mt-6">{{ label }}</p>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LoadingComponent',
  props: {
    label: { type: String, default: 'Loading data…' },
    fullscreen: { type: Boolean, default: false },
  },
  data() {
    return {
      wildlifeIcons: ['mdi-leaf', 'mdi-paw', 'mdi-tree'],
      selectedIcon: 'mdi-leaf',
    };
  },
  mounted() {
    this.selectedIcon = this.wildlifeIcons[Math.floor(Math.random() * this.wildlifeIcons.length)];
  },
};
</script>

<style scoped>
.loading-container { min-height: 200px; margin: 0; background: none; }
.loading-fullscreen { min-height: 100vh; }
.transparent-card {
  background: rgba(255,255,255,0.85) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.10);
  border-radius: 24px;
}
.spinner-bounce {
  display: flex;
  justify-content: center;
  align-items: center;
  animation: bounce 1.2s infinite alternate;
}
.spinner-center {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
@keyframes bounce {
  0% { transform: translateY(0); }
  100% { transform: translateY(-18px); }
}
.spin-icon {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  100% { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  .spinner-bounce, .spin-icon { animation: none; }
}
</style>
